import React from 'react';
import CreateIcon from "@mui/icons-material/Create";
import DeleteIcon from "@mui/icons-material/Delete";
import { Box, Button, TextField, Select, MenuItem, FormControl, Stack } from "@mui/material";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import { useCallback, useMemo, useState, useEffect } from 'react';
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { ToastContainer, toast } from "react-toastify";
import axios from "../../../utils/fvAxios";

import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useTranslation } from "react-i18next";
import { IconButton } from '@mui/material'
import UndoIcon from '@mui/icons-material/Undo';
import RedoIcon from '@mui/icons-material/Redo';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { HasScreenPermissions, HasPermissions } from '../../../utils/Token';
import INFO from '../../../pages/commom/RouteUrlInfo.json';
import PER from "../../../utils/Enums.json";


export default function EditclientIntrocontent({ Alignments, orgs, refe }) {
  const { t } = useTranslation();
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [introcontent, setIntroCONTENT] = useState([]);
  const [index, setIndex] = React.useState(0);
  const [alignment, setAlignment] = React.useState("");
  const [refresh, setRefresh] = useState(false);



  useEffect(() => {
    if (Alignments) {
      axios.get("Companies/GetIntroHeaderFootersList?templateId=" + Alignments + "&clientId=" + orgs
      ).then((res) => {
        if (res?.data?.responseCode === 100) {
          setIntroCONTENT(res?.data?.data)
        }
        else {
          setError(res?.data?.responseMessage);
        }
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        setIsLoading(false);
      });
    } else { }
  }, [Alignments, refresh, refe]);


  const [open, setOpen] = React.useState(false);

  const handleClickOpen = (r) => {
    setRegistration(r?.positionType)
    setSave(r)
    setSectionValue(r?.templateSectionsName)
    setEmail(r?.positionTitle)
    setBody(r?.postionContent)
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [intro, setIntro] = useState([]);
  const [save, setSave] = useState();
  const [selectedValue, setSelectedValue] = useState('');

  const [SectionValue, setSectionValue] = useState('');
  const [email, setEmail] = useState('');
  const [registration, setRegistration] = useState('0');
  const [Body, setBody] = useState("");

  const handleChange1 = (event) => {
    setSelectedValue(event?.target?.value);
  };
  const ChangeBody = (data) => {
    setBody(data);
  }
  const [openpop, setOpenpop] = React.useState(false);
  const [EmpId, setEmpId] = React.useState();


  const handleClickOpenpop = (e) => {
    setEmpId(e)
    setOpenpop(true);
  };

  const handlePopClose = () => {
    setOpenpop(false);
  };

  const handleSubmit = (event) => {
    event?.preventDefault();


    if (!selectedValue || !Body || !SectionValue) {
      toast.error("Please fill all the mandatory fields", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

    } else {
      setIsLoading(true);
      setOpen(false);
      const data = {
        organizationId: Number(orgs),
        sectionId: save?.templateSectionId,
        headerFooterId: save?.headerFooterId,
        templateId: selectedValue,
        sectionName: SectionValue,
        positionType: Number(registration),
        positionTitle: email,
        positionContent: Body


      }
      axios
        .post("Companies/AddNewHeaderFooter", data,

          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .then((res) => {
          if (res?.data?.responseCode == "100") {

            toast.success(res?.data?.responseMessage, {
              position: "top-right",
              autoClose: 4000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            setRefresh(!refresh);

          } else {
            toast.error(res?.data?.responseMessage, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            // setOpen(false);
          }

        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }

  };
  const handleDelete = () => {
    setIsLoading(true);
    setOpenpop(false);
    axios
      .post("Companies/DeleteHeaderFooter?headerFooterId=" + EmpId,
        {
          headers: { "Content-Type": "application/json" },
        }
      )
      .then((res) => {
        if (res?.data?.responseCode == "100") {
          toast.success("Success", {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setRefresh(!refresh);
        } else {
          toast.error(res?.data?.responseMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          // setOpen(false);
        }

      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });


  };







  useEffect(() => {
    axios.get("Companies/GetTemplateDetails?organizationId=" + orgs
    ).then((res) => {
      if (res?.data?.responseCode === 100) {
        const data = res?.data?.data;
        setIntro(data)
        setAlignment(data[0]?.value);
        setSelectedValue(Alignments);

      }
      else {
        setError(res?.data?.responseMessage);
      }
    }).catch(err => {
      console.log(err)
    }).finally(() => {
      setIsLoading(false);
    });


  }, [Alignments]);
  function handleDocumentClick(event, i) {
    event?.preventDefault();

    axios

      .get(
        "Documents/DownloadDocument?idAsFileName=" +
        i?.fileName,
        {
          responseType: 'blob', // Set the response type to blob
        }
      )
      .then((res) => {
        if (res?.data instanceof Blob) {
          // Create a blob URL for the downloaded file
          const blobUrl = URL.createObjectURL(res?.data);

          // Open the file in a new tab
          const newTab = window.open(blobUrl);
          if (newTab) {
            newTab.opener = null; // Prevent the new tab from having access to the current page
            newTab.location = blobUrl;
          }
        } else {
          // Handle the case where the response is not a Blob
          console.error('Unexpected response format');
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }
  const formats = [
    "strike",
    "size",
    'font',
    'size',
    'bold',
    'italic',
    'underline',
    'background',
    'list',
    'align',

    // 'image',
    'color',
    'indent',
    'clean',
    'blockquote', 'script'

  ];

  const modules = {
    toolbar: [
      ['undo', 'redo'],
      [{ 'size': [] }],
      [{ 'font': [] }],
      [{ 'script': 'sub' }, { 'script': 'super' }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],

      ['clean'],

      [{ 'color': [] }, { 'background': [] }],
      [{ 'align': [] }],
      [{ 'indent': '-1' }, { 'indent': '+1' }],
    ],
  };



  const handleUndo = () => {
    const quill = quillRef.current.getEditor();
    quill.history.undo();
  };

  const handleRedo = () => {
    const quill = quillRef.current.getEditor();
    quill.history.redo();
  };
  const quillRef = React.createRef();
  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >

        <DialogContent sx={{ padding: "48px 48px" }} >
          <DialogTitle
            sx={{
              textAlign: "center",
              fontWeight: 500,
              fontSize: 20,
            }}
          >
            <span style={{ fontSize: "larger" }} >Edit Introduction Content</span>
          </DialogTitle>

          <DialogActions >
            <div>
              <DialogActions >
                <div>
                  <div className='mt-3' >
                    <span style={{ color: "#3E4A62" }}>Template<span style={{ color: "red" }}>*</span></span>
                    <br />
                    <Select sx={{
                      width: "100%", minWidth: "",
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },

                      fontFamily: "Arial, FontAwesome",
                    }}

                      size="small" value={selectedValue} onChange={handleChange1}>
                      {intro?.map((option) => (
                        <MenuItem key={option?.value} value={option?.value}>
                          {option?.text}
                        </MenuItem>
                      ))}
                    </Select>

                  </div>

                  <div className='mt-3'>
                    <span style={{ color: "#3E4A62" }}> Section Name</span>
                    <br />
                    <TextField

                      placeholder="Section Name"
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        width: "100%",
                        backgroundColor: "#fff",
                        marginTop: "2px",
                        marginBottom: "5px",
                      }}

                      variant="outlined"
                      size="small"
                      value={SectionValue || ""}
                      onChange={(e) => setSectionValue(e?.target?.value)}

                    />


                  </div>

                  <div className='mt-3'>
                    <span style={{ color: "#3E4A62" }}>Header / Footer<span style={{ color: "red" }}>*</span></span>
                    <br />
                    <FormControl>
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={registration}
                        onChange={(event) => setRegistration(event?.target?.value)}
                      >
                        <FormControlLabel
                          value="0"
                          control={<Radio />}
                          label="Header"
                        />
                        <FormControlLabel
                          value="1"
                          control={<Radio />}
                          label="Footer"
                        />
                      </RadioGroup>

                    </FormControl>
                  </div>
                  <TextField
                    placeholder="Title"
                    sx={{
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },
                      width: "100%",
                      backgroundColor: "#fff",
                      marginTop: "2px",
                      marginBottom: "5px",


                    }}
                    value={email || ""}
                    onChange={(e) => setEmail(e?.target?.value)}
                    variant="outlined"
                    size="small"


                  />
                  <br />

                  <span style={{ color: "#3E4A62" }}>Content <span style={{ color: "red" }}>*</span></span>
                  <div style={{ width: "500px" }}>
                    {/* <CKEditor
                      editor={ClassicEditor}
                      data={Body}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        ChangeBody(data);
                        setBody(data)
                      }}
                    /> */}
                    <div>
                      <IconButton onClick={handleUndo} sx={{ marginBottom: "-64px" }}>
                        <UndoIcon />
                      </IconButton>
                      <IconButton onClick={handleRedo} sx={{ marginBottom: "-64px" }}>
                        <RedoIcon />
                      </IconButton>

                      <ReactQuill
                        ref={quillRef}
                        theme="snow"
                        modules={modules}
                        formats={formats}
                        value={Body}
                        onChange={setBody}
                      />
                    </div>
                  </div>
                  <DialogActions >
                    <div className="login-help__buttonContainer mt-4">
                      <Button variant="contained" className="login-help-button-cancel mx-2" onClick={handleClose}>Cancel</Button>
                      <Button variant="contained" className="login-button-request mx-2" onClick={handleSubmit}>Save</Button>
                    </div>

                  </DialogActions>
                </div >
              </DialogActions>
            </div>
          </DialogActions>
        </DialogContent>
      </Dialog>
      <Dialog
        open={openpop}
        keepMounted
        onClose={handlePopClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle> {"Are you sure? you want to permanently delete this content? This operation is irreversible."}</DialogTitle>
        <DialogContent>

        </DialogContent>
        <DialogActions>
          <Button onClick={handlePopClose}>{"Cancel"}</Button>
          <Button onClick={handleDelete}>{t('VendorDetails.label8')}</Button>
        </DialogActions>
      </Dialog>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ToastContainer />
      {introcontent?.map((r) => (
        <Box key={r?.headerFooterId}>
          <Box sx={{ padding: "10px", backgroundColor: "#fff", marginTop: "20px" }}>
            <Box
              sx={{ backgroundColor: "#F2F4F7", padding: "10px", color: "667085" }}
            >
              {r?.positionTitle}
            </Box>
            <Box
              sx={{
                display: "flex",

                paddingLeft: "20px",
                paddingRight: "20px",
                "& hr": { mx: 0.5 },
              }}
            >
              {/* <Stack direction="row" spacing={2}> */}
              <span
                style={{
                  marginRight: "auto",
                  textDecoration: "none",
                  marginTop: "10px",
                  marginBottom: "10px",
                  color: "#3E4A62",
                }}
              >

                <div dangerouslySetInnerHTML={{ __html: r?.postionContent }} />
              </span>
              <div style={{ alignItems: "center" }}>
                <Stack direction="row" spacing={1} className='ml-2' sx={{ marginLeft: "34px", marginTop: "5px" }}>
                  {HasPermissions(INFO?.AddNewHeaderFooter?.actionName, PER?.ScreenPermissions?.Modify) &&
                    <CreateIcon sx={{ color: "#667085", marginRight: "5px" }} onClick={() => handleClickOpen(r)} />
                  }
                  {HasPermissions(INFO?.AddNewHeaderFooter?.actionName, PER?.ScreenPermissions?.Delete) &&
                    <DeleteIcon sx={{ color: "#667085" }} onClick={() => handleClickOpenpop(r?.headerFooterId)} />
                  }
                </Stack>
              </div>

              {/* </Stack> */}
            </Box>
            {r?.documentsList?.map((e) => (
              <p style={{ color: "#2A93DB", marginLeft: "10px", cursor: "pointer" }} key={e?.fileName} onClick={(event) => handleDocumentClick(event, e)} >
                <InsertDriveFileOutlinedIcon /> {e?.documentName}
              </p>
            ))}
          </Box>

        </Box>
      ))}












      {/* <Box sx={{ padding: "10px", backgroundColor: "#fff", marginTop: "20px" }}>
        <Box
          sx={{ backgroundColor: "#F2F4F7", padding: "10px", color: "667085" }}
        >
          Prequalification
        </Box>
        <Box
          sx={{
            display: "flex",

            paddingLeft: "20px",
            paddingRight: "20px",
            "& hr": { mx: 0.5 },
          }}
        >
          <span
            style={{
              marginRight: "auto",
              textDecoration: "none",
              marginTop: "10px",
              marginBottom: "10px",
              color: "#3E4A62",
            }}
          >
           All service providers must be prequalified, including subcontractors. Please review the Prequalification Requirements section for specifics.
          </span>

          <CreateIcon sx={{ color: "#667085", marginRight: "5px" }} />

          <DeleteIcon sx={{ color: "#667085" }} />
        </Box>
        
      </Box>
      <Box sx={{ padding: "10px", backgroundColor: "#fff", marginTop: "20px" }}>
        <Box
          sx={{ backgroundColor: "#F2F4F7", padding: "10px", color: "667085" }}
        >
          Employee Safety Orientation
        </Box>
        <Box
          sx={{
            display: "flex",

            paddingLeft: "20px",
            paddingRight: "20px",
            "& hr": { mx: 0.5 },
          }}
        >
          <span
            style={{
              marginRight: "auto",
              textDecoration: "none",
              marginTop: "10px",
              marginBottom: "10px",
              color: "#3E4A62",
            }}
          >
           All employees working onsite must complete online safety orientation. Please review the Prequalification Requirements section for specifics.
          </span>

          <CreateIcon sx={{ color: "#667085", marginRight: "5px" }} />

          <DeleteIcon sx={{ color: "#667085" }} />
        </Box>
      
      </Box>
      <Box sx={{ padding: "10px", backgroundColor: "#fff", marginTop: "20px" }}>
        <Box
          sx={{ backgroundColor: "#F2F4F7", padding: "10px", color: "667085" }}
        >
          Payment
        </Box>
        <Box
          sx={{
            display: "flex",

            paddingLeft: "20px",
            paddingRight: "20px",
            "& hr": { mx: 0.5 },
          }}
        >
          <span
            style={{
              marginRight: "auto",
              textDecoration: "none",
              marginTop: "10px",
              marginBottom: "10px",
              color: "#3E4A62",
            }}
          >
           A non-refundable payment shall be made by credit card or PayPal account. This is an annual fee:
            <br />
            <br />
            <b>
            $85.00:  For CIE prequalification. If you also prequalify for other FIRST, VERIFY clients within a 12-month period, your total annual cost will not exceed $1,000. The 12-month period begins on the date you submit the questionnaire for your first client and renews on each anniversary.
No charge:  For any client questionnaires submitted within the 12-month period after the $1,000 cap has been reached.
$185.00:  Per prequalification, if spreadsheet or paper copies are sent to FIRST, VERIFY for data entry. This fee shall apply regardless of how many prequalifications are completed in a 12 month period.
$20.00:  Safety orientation fee per employee, per year. There is a cap of $500 per calendar year
            </b>
          </span>

          <CreateIcon sx={{ color: "#667085", marginRight: "5px" }} />

          <DeleteIcon sx={{ color: "#667085" }} />
        </Box>
       
      </Box>
      <Box sx={{ padding: "10px", backgroundColor: "#fff", marginTop: "20px" }}>
        <Box
          sx={{ backgroundColor: "#F2F4F7", padding: "10px", color: "667085" }}
        >
          Who Sees Your Information
        </Box>
        <Box
          sx={{
            display: "flex",

            paddingLeft: "20px",
            paddingRight: "20px",
            "& hr": { mx: 0.5 },
          }}
        >
          <span
            style={{
              marginRight: "auto",
              textDecoration: "none",
              marginTop: "10px",
              marginBottom: "10px",
              color: "#3E4A62",
            }}
          >
            This information will be used for contractor/service provider prequalification purposes at CIE. All of the information that you provide will be held in the strictest confidence and will only be viewed by the following personnel:
            <br />
            <br />
            <b>
            FIRST, VERIFY  Employees assigned to the CIE account

            </b>
            <br />
            <b>
        
CIE management personnel
            </b>
          </span>

          <CreateIcon sx={{ color: "#667085", marginRight: "5px" }} />

          <DeleteIcon sx={{ color: "#667085" }} />
        </Box>
       
      </Box> */}
    </>
  )
}
